import React from "react"
import { usePersonnelDetailsContext } from "../PersonnelDetails"
import SuiviList from "./_SuiviList"

const Suivi = () => {
     const context = usePersonnelDetailsContext()
     const personnelId = context.detailsQuery.data?.personnel.id

     return (
          <div className="card">
               <div className="card-header">
                    <h3 className="card-title">Journal des actions</h3>
               </div>
               <div className="card-body">
                    <SuiviList personnelId={personnelId} />
               </div>
          </div>
     )
}

export default Suivi
